import React, { useState, useEffect } from 'react';
import Loader from './Loader';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import ThemeWrapper from '../ThemeWrapper ';
import LazyLoad from 'react-lazyload';
import GuideSidebar from './GuideSidebar';

const ListingStep2 = ({ formData, handleChange, prevStep, onRegisterSave }) => {
  const { listingId } = formData;
  const [listingData, setListingData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [propertyItem, setPropertyItem] = useState(null);
  const [categoryId, setCategoryId] = useState('');
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [nextLoading, setNextLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getCategories}`,
          data: formData,
        });

        if (response.data.status === 'category') {
          const filteredCategories = response.data.property_cat_list.filter(
            (category) => !category.is_it_hotel
          );
          setCategories(filteredCategories);
          setLoading(false);
        } else {
          toast.error('An error occurred while fetching data.');
        }
      } catch (err) {
        toast.error(err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setPropertyItem(response.data.updated_property_item);
          setCategoryId(String(response.data.updated_property_item.category_id));
          setQuestion(response.data.updated_property_item.questions);
        } else {
          toast.error('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchCategories();
    fetchListingData();
  }, []);

  /*useEffect(() => {
    if (nextStep) {
      saveListing();
    }
  }, [listingData, categoryId]);*/

  const saveListing = async () => {
    const hostData = getItemFromLocalStorage('hostProfile');
    const listing_id = listingId;
    const ts = Date.now();

    const categoryInfo = categories.find(cat => cat.category_id === parseInt(categoryId));

    if (!categoryId || !categoryInfo) {
      toast.error('Please select a property type to continue.');
      return false;
    }

    const updatedPropertyItem = {
      category_id: categoryId,
      category_info: {
        category_id: categoryInfo.category_id,
        category_image: categoryInfo.category_image,
        category_image_url: categoryInfo.category_image_url,
        category_name: categoryInfo.category_name,
      }
    };

    const mergedData = { ...listingData, ...updatedPropertyItem };

    let catData = new FormData();
    catData.append('token', hostData.host_access_token);
    catData.append('listing_id', listing_id);
    catData.append('data', JSON.stringify(mergedData));
    catData.append('ts', ts);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        url: `${params.baseURL}${params.endpoints.updateListing}`,
        data: catData,
      });

      if (response.data.status === 'done') {
        //toast.success('Property type updated successfully!');
        return true;
      } else {
        toast.error('Failed to save property type data');
        return false;
      }
    } catch (err) {
      toast.error('An error occurred while saving the property type: ' + err.message);
      return false;
    }
  };

  // useEffect(() => {


  //   if (onRegisterSave) {
  //     onRegisterSave(saveListing);
  //   }
  // }, [categoryId, listingData, categories, listingId, onRegisterSave]);

  const handleCategoryChange = (e) => {
    console.log(categoryId);
    setCategoryId(e.target.value);
  };

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <ThemeWrapper categoryId={categoryId}>
      <button id='host-listing-trigger-2' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>
      <div className="fade-in">
        <div className='row'>
          <div className='col-md-8'>
            <div className='ws-cl-header'>
              <div>
                <h4 className='ws-title'>Define your hosting space</h4>
              </div>
            </div>
            {loading ? <p>Loading...</p> : null}
            <div className='st1-desc-box'>
              {categories.length > 0 ? (
                <div className='cat-box'>
                  {categories.map((data) => (
                    <label className='cat-label' key={data.category_id}>
                      <input
                        type="radio"
                        name="category"
                        value={data.category_id}
                        checked={categoryId === String(data.category_id)}
                        onChange={handleCategoryChange}
                      />
                      <span>
                        {/*<LazyLoad
                          height={40}
                          offset={40}
                          placeholder={<div className="img-placeholder"><div className="spinner"></div></div>}
                          once
                        >
                          
                        </LazyLoad>*/}
                        <img
                          src={data.category_image_url && data.category_image_url.trim() !== ''
                            ? data.category_image_url
                            : 'https://stcontent.blr1.digitaloceanspaces.com/stays/1722843850_stct.png'}
                          alt={data.category_name || 'Untitled Listing'}
                          className='cat-img'
                          onError={(e) => { e.target.src = 'https://stcontent.blr1.digitaloceanspaces.com/stays/1722843850_stct.png'; }}
                        />
                        <p>{data.category_name}</p>
                      </span>
                    </label>
                  ))}
                </div>
              ) : (
                <p>No data found</p>
              )}
            </div>

          </div>
          <div className='col-md-4 p-0'>
            <GuideSidebar slug="step-2" />
          </div>
        </div>
      </div>
    </ThemeWrapper>
  );
};

export default ListingStep2;
